import * as React from 'react';

import {AudienceInfo} from './audiences/audience-info';
import {EngagementStats} from './engagement-stats/engagement-stats';

import styles from './peep-email-marketing-section.module.css';

type Props = {
    contactId: string;
};

export function PeepEmailMarketingSection(props: Props) {
    return (
        <div className={styles.container}>
            <AudienceInfo {...props} />
            <EngagementStats {...props} />
        </div>
    );
}
